<!-- eslint-disable -->
<template lang="pug">
    div.generator-form
        div.generator-form__divider
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_generator_comment')")
            cs-input(v-model="selectedGame.text")
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_mode')")
            cs-multiselect(
                :multiple="false",
                :options="modes",
                :show-labels="false",
                :allow-empty="false",
                label="label"
                placeholder="",
                :value="{label: $i18n.t('trainer')[selectedGame.parameters.mode], value: selectedGame.parameters.mode}"
                @select="selectMode"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_difficulty')")
            cs-multiselect(
                :multiple="false",
                :options="difficult",
                :show-labels="false",
                :allow-empty="false",
                placeholder="",
                label="label"
                track-by="name"
                :value="{label: $i18n.t('common')[selectedGame.parameters.difficult], name: selectedGame.parameters.difficult}"
                @select="selectDifficult"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_transitionThrough')")
            cs-multiselect(
                :multiple="false",
                :options="jumpOver",
                :show-labels="false",
                :allow-empty="true",
                placeholder="",
                v-model="selectedGame.parameters.jumpOver",
                :disabled="!isAllowJumpOver"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_numOfActions')")
            cs-select.generator-form__select(
                v-model="selectedGame.parameters.amountOfActions",
                :firstNumber="2",
                :options="actions",
                placeholder=""
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_numOfExamples')")
            cs-select.generator-form__select(
                v-model="selectedGame.parameters.amountOfExamples",
                :options="examples",
                placeholder=""
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_fractions')")
            cs-checkbox.generator-form__checkbox(
                :checked="selectedGame.parameters.fractions"
                :disabled="fractionsDisabled"
                @change="fractionsHandler"
            )
        form-group.generator-form__form-group(
            v-if="selectedGame.parameters.fractions",
            :label="$i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints')"
        )
            cs-select.generator-form__select(
                v-model="selectedGame.parameters.fractionalPart",
                :options="fractionalParts",
                placeholder=""
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_mirror')")
            cs-checkbox.generator-form__checkbox(
                v-model="selectedGame.parameters.mirror",
                :disabled="mirrorDisabled"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_roundNumbers')")
            cs-checkbox.generator-form__checkbox(
                :checked="selectedGame.parameters.roundNumbers",
                :disabled="roundNumbersDisabled",
                @change="roundNumbersHandler"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_positiveAnswers')")
            cs-checkbox.generator-form__checkbox(
                v-model="selectedGame.parameters.positiveAnswers",
                :disabled="positiveAnswersDisabled"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_negativeAnswers')")
            cs-checkbox.generator-form__checkbox(
                v-model="selectedGame.parameters.negativeAnswers",
                :disabled="negativeAnswersDisabled"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_interimAnswers')")
            cs-checkbox.generator-form__checkbox(
                v-model="selectedGame.parameters.interimAnswers",
                :disabled="interimAnswersDisabled"
            )
        template(
            v-for="x in stayInOptions"
            v-if="isStayInXAvailable(x)"
        )
            form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_stayIn', {x})")
                cs-checkbox.generator-form__checkbox(
                    v-model="selectedGame.parameters.stayIn",
                    :disabled="!isStayInXAvailable(x)"
                )
        div.generator-form__divider
        div.generator-form__checkbox-container
            cs-checkbox.generator-form__checkbox(
                v-model="selectedGame.parameters.combining",
                :disabled="combiningDisabled"
            ) {{ $i18n.t('trainer.trainer_gameFormSetting_combiningNumOfDigits') }}
        div.generator-form__numbers-container(v-if="selectedGame.parameters.combining && !selectedGame.parameters.roundNumbers && !selectedGame.parameters.fractions")
            combining-digit-capacities(
                :combiningDigitCapacityLabels="combiningDigitCapacityLabels",
                :filteredCombiningDigitCapacities="filteredCombiningDigitCapacities",
                :combiningDigitCapacities="selectedGame.parameters.combiningDigitCapacities",
                @changeCombiningDigitCapacities="changeCombiningDigitCapacities"
            )
        div.generator-form__numbers-container
            div.generator-form__numbers-header {{ $i18n.t('trainer.trainer_gameFormSetting_simple') }}
            div.generator-form__numbers
                cs-checkbox.generator-form__checkbox(
                    v-for="(number, index) in simple",
                    :key="'simple' + number",
                    :checked="selectedGame.parameters.simple.includes(number)",
                    @change="setNumber(number, 'simple')",
                    :disabled="isSimpleDisabled(number)"
                ) {{ number }}
            div.generator-form__numbers
                cs-checkbox.generator-form__checkbox(
                    :checked="checkedSelectedItems('simple')"
                    @change="selectAllForGroup('simple')"
                    :disabled="simpleDisabled"
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAll') }}
        div.generator-form__numbers-container
            div.generator-form__numbers-header {{ $i18n.t('trainer.trainer_gameFormSetting_brothers') }}
            div.generator-form__numbers
                cs-checkbox.generator-form__checkbox(
                    v-for="(number, index) in 4",
                    :key="'brothers' + (5 - number)",
                    :checked="selectedGame.parameters.brothers.includes(5 - number)",
                    @change="setNumber(5 - number, 'brothers')",
                    :disabled="brothersDisabled"
                ) {{ 5 - number }}
            div.generator-form__numbers
                cs-checkbox.generator-form__checkbox(
                    :checked="checkedSelectedItems('brothers')"
                    @change="selectAllForGroup('brothers')"
                    :disabled="brothersDisabled"
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAll') }}
            div.generator-form__numbers
                cs-checkbox.generator-form__checkbox(
                    v-model="selectedGame.parameters.brothersOptions.onlyAddition",
                    :disabled="areBrothersOnlyOptionsDisabled"
                ) {{ $i18n.t('trainer.trainer_gameFormSetting_onlyAddition') }}
                cs-checkbox.generator-form__checkbox(
                    v-model="selectedGame.parameters.brothersOptions.onlySubtraction",
                    :disabled="areBrothersOnlyOptionsDisabled"
                ) {{ $i18n.t('trainer.trainer_gameFormSetting_onlySubtraction') }}
        div.generator-form__numbers-container
            div.generator-form__numbers-header {{ $i18n.t('trainer.trainer_gameFormSetting_friends') }}
            div.generator-form__numbers
                cs-checkbox.generator-form__checkbox(
                    v-for="(number, index) in 9",
                    :key="'friends' + (10 - number)",
                    :checked="selectedGame.parameters.friends.includes(10 - number)",
                    @change="setNumber(10 - number, 'friends')"
                    :disabled="isOnlyJumpOverSetting(10 - number, 'friends') || friendsDisabled"
                ) {{ 10 - number }}
            div.generator-form__numbers
                cs-checkbox.generator-form__checkbox(
                    :checked="checkedSelectedItems('friends')"
                    @change="selectAllForGroup('friends')"
                    :disabled="friendsDisabled"
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAll') }}
            div.generator-form__numbers(v-if="showNegativeAnswersHelpText")
                help-text(
                    slot="help-text"
                    v-text="$i18n.t('trainer.trainer_gameFormHelpText_selectMoreOptions')"
                    class="add-sub-form__help-text"
                )
            div.generator-form__numbers
                cs-checkbox.generator-form__checkbox(
                    v-model="selectedGame.parameters.friendsOptions.onlyAddition",
                    :disabled="areFriendsOnlyOptionsDisabled"
                ) {{ $i18n.t('trainer.trainer_gameFormSetting_onlyAddition') }}
                cs-checkbox.generator-form__checkbox(
                    v-model="selectedGame.parameters.friendsOptions.onlySubtraction",
                    :disabled="areFriendsOnlyOptionsDisabled"
                ) {{ $i18n.t('trainer.trainer_gameFormSetting_onlySubtraction') }}
        div.generator-form__numbers-container
            div.generator-form__numbers-header {{ $i18n.t('trainer.trainer_gameFormSetting_brothersAndFriends') }}
            div.generator-form__numbers
                cs-checkbox.generator-form__checkbox(
                    v-for="(number, index) in 4",
                    :key="'friends&brothers' + (5 + number)",
                    :checked="selectedGame.parameters.brothersAndFriends.includes(5 + number)",
                    @change="setNumber(5 + number, 'brothersAndFriends')"
                    :disabled="isOnlyJumpOverSetting(5 + number, 'brothersAndFriends') || brothersAndFriendsDisabled"
                ) {{ 5 + number }}
            div.generator-form__numbers
                cs-checkbox.generator-form__checkbox(
                    :checked="checkedSelectedItems('brothersAndFriends')"
                    @change="selectAllForGroup('brothersAndFriends')"
                    :disabled="brothersAndFriendsDisabled"
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAll') }}
            div.generator-form__numbers(v-if="showNegativeAnswersHelpText")
                help-text(
                    slot="help-text"
                    v-text="$i18n.t('trainer.trainer_gameFormHelpText_selectMoreOptions')"
                    class="add-sub-form__help-text"
                )
            div.generator-form__numbers
                cs-checkbox.generator-form__checkbox(
                    v-model="selectedGame.parameters.brothersAndFriendsOptions.onlyAddition",
                    :disabled="areBrothersAndFriendsOnlyOptionsDisabled"
                ) {{ $i18n.t('trainer.trainer_gameFormSetting_onlyAddition') }}
                cs-checkbox.generator-form__checkbox(
                    v-model="selectedGame.parameters.brothersAndFriendsOptions.onlySubtraction",
                    :disabled="areBrothersAndFriendsOnlyOptionsDisabled"
                ) {{ $i18n.t('trainer.trainer_gameFormSetting_onlySubtraction') }}

        div.generator__divider
        div.generator__buttons-container
            cs-button.generator__button(
                @click="$emit('cancel')",
                pattern="primary-outline"
            )
                | {{ $i18n.t('trainer.trainer_generator_cancel') }}
            cs-button.generator__button(
                @click="$emit('generate')",
                :disabled="isLoading || showNegativeAnswersHelpText"
            )
                | {{ $i18n.t('trainer.trainer_generator_generate') }}
</template>

<script>
    /*eslint-disable*/
    import CombiningDigitCapacities from './shared/CombiningDigitCapacity.vue'
    import combiningCapacitiesMixin from './utils/combiningCapacitiesMixin'

    export default {
        components: {
            CombiningDigitCapacities
        },
        props: {
            selectedGame: Object,
            isLoading: Boolean
        },
        mixins: [combiningCapacitiesMixin],
        data () {
            return {
                modes: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbacus'),
                        value: 'На счетах'
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_inMind'),
                        value: 'В уме'
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_any'),
                        value: 'Любой'
                    }
                ],
                difficult: [
                    {
                        label: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                        name: 'Однозначные цифры',
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        name: 'Двузначные цифры',
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        name: 'Трехзначные цифры',
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        name: 'Четырехзначные цифры',
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                        name: 'Пятизначные цифры',
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_sixDigitsNum'),
                        name: 'Шестизначные цифры',
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_sevenDigitsNum'),
                        name: 'Семизначные цифры',
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_eightDigitsNum'),
                        name: 'Восьмизначные цифры',
                    }
                ],
                simple: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                brothers: [4, 3, 2, 1],
                friends: [9, 8, 7, 6, 5, 4, 3, 2, 1],
                brothersAndFriends: [6, 7, 8, 9],
                jumpOver: [50, 100],
                stayInOptions: [100, 1000],
                examples: 100,
                actions: 25,
                fractionalParts: 2
            }
        },
        watch: {
            isAllowJumpOver(val) {
                if (!val) {
                    this.selectedGame.parameters.jumpOver = null;
                }
            },
            'selectedGame.parameters.friendsOptions.onlyAddition' (val) {
                if (val) {
                    this.selectedGame.parameters.friendsOptions.onlySubtraction = false;
                }
            },
            'selectedGame.parameters.friendsOptions.onlySubtraction' (val) {
                if (val) {
                    this.selectedGame.parameters.friendsOptions.onlyAddition = false;
                }
            },
            'selectedGame.parameters.brothersOptions.onlyAddition' (val) {
                if (val) {
                    this.selectedGame.parameters.brothersOptions.onlySubtraction = false;
                }
            },
            'selectedGame.parameters.brothersOptions.onlySubtraction' (val) {
                if (val) {
                    this.selectedGame.parameters.brothersOptions.onlyAddition = false;
                }
            },
            'selectedGame.parameters.brothersAndFriendsOptions.onlyAddition' (val) {
                if (val) {
                    this.selectedGame.parameters.brothersAndFriendsOptions.onlySubtraction = false;
                }
            },
            'selectedGame.parameters.brothersAndFriendsOptions.onlySubtraction' (val) {
                if (val) {
                    this.selectedGame.parameters.brothersAndFriendsOptions.onlyAddition = false;
                }
            },
            'selectedGame.parameters.negativeAnswers' (val) {
                if (val) {
                    this.selectedGame.parameters.simple = this.simple;
                    this.selectedGame.parameters.brothers = this.brothers;
                }
            },
            'selectedGame.parameters.jumpOver' (val) {
                if (val) {
                    this.selectedGame.parameters.stayIn = false;
                    this.selectedGame.parameters.interimAnswers = false;
                    this.selectedGame.parameters.simple = this.simple;
                    this.selectedGame.parameters.brothers = this.brothers;
                    if (
                            !this.selectedGame.parameters.friends.length
                            && !this.selectedGame.parameters.brothersAndFriends.length
                    ) {
                        this.setNumber(9, 'friends')
                    }
                }
            },
            'selectedGame.parameters.stayIn' (val) {
                if (val) {
                    this.selectedGame.parameters.interimAnswers = false;
                }
            },
            'selectedGame.parameters.interimAnswers' (val) {
                if (val) {
                    this.selectedGame.parameters.simple = this.simple;
                    this.selectedGame.parameters.brothers = this.brothers;
                    this.selectedGame.parameters.friends = this.friends;
                    this.selectedGame.parameters.brothersAndFriends = this.brothersAndFriends;
                }
            },
            areBrothersOnlyOptionsDisabled (val) {
                if (val) {
                    this.selectedGame.parameters.brothersOptions.onlyAddition = false;
                    this.selectedGame.parameters.brothersOptions.onlySubtraction = false;
                }
            },
            areFriendsOnlyOptionsDisabled (val) {
                if (val) {
                    this.selectedGame.parameters.friendsOptions.onlyAddition = false;
                    this.selectedGame.parameters.friendsOptions.onlySubtraction = false;
                }
            },
            areBrothersAndFriendsOnlyOptionsDisabled (val) {
                if (val) {
                    this.selectedGame.parameters.brothersAndFriendsOptions.onlyAddition = false;
                    this.selectedGame.parameters.brothersAndFriendsOptions.onlySubtraction = false;
                }
            },
            mirrorDisabled (val) {
                if (val) {
                    this.selectedGame.parameters.mirror = false;
                }
            },
            combiningDisabled (val) {
                if (val) {
                    this.selectedGame.parameters.combining = false;
                }
            },
            roundNumbersDisabled (val) {
                if (val) {
                    this.selectedGame.parameters.roundNumbers = false;
                }
            },
            'selectedGame.parameters.combining' (val) {
                this.selectedGame.parameters.combiningDigitCapacities = [];
                if (val) {
                    this.fillCombiningDigitCapacities();
                }
            },
            'selectedGame.parameters.difficult' (val) {
                if (this.stayInOptions.every(option => !this.isStayInXAvailable(option))) {
                    this.selectedGame.parameters.stayIn = false;
                }
                if (this.selectedGame.parameters.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
        },
        computed: {
            simpleDisabled () {
                return !!this.selectedGame.parameters.brothers.length
                        || !!this.selectedGame.parameters.friends.length
                        || !!this.selectedGame.parameters.brothersAndFriends.length
                        || this.selectedGame.parameters.negativeAnswers
                        || !!this.selectedGame.parameters.interimAnswers;
            },
            brothersDisabled() {
                return this.selectedGame.parameters.negativeAnswers
                        || !!this.selectedGame.parameters.interimAnswers
                        || !!this.selectedGame.parameters.jumpOver;
            },
            friendsDisabled() {
                return !!this.selectedGame.parameters.interimAnswers;
            },
            brothersAndFriendsDisabled() {
                return !!this.selectedGame.parameters.interimAnswers;
            },
            positiveAnswersDisabled() {
                return this.selectedGame.parameters.positiveAnswers && !this.selectedGame.parameters.negativeAnswers;
            },
            negativeAnswersDisabled() {
                return this.selectedGame.parameters.negativeAnswers && !this.selectedGame.parameters.positiveAnswers;
            },
            mirrorDisabled() {
                return this.selectedGame.parameters.difficult === 'Однозначные цифры'
                        || this.selectedGame.parameters.fractions || this.selectedGame.parameters.roundNumbers
            },
            roundNumbersDisabled () {
                return this.selectedGame.parameters.difficult === 'Однозначные цифры'
                        || this.selectedGame.parameters.fractions || this.selectedGame.parameters.mirror
            },
            fractionsDisabled () {
                return this.selectedGame.parameters.roundNumbers || this.selectedGame.parameters.mirror
            },
            isAllowJumpOver() {
                return !this.selectedGame.parameters.combining
                        && (
                                (
                                        this.selectedGame.parameters.friends
                                        && this.selectedGame.parameters.friends.length > 0
                                ) || (
                                        this.selectedGame.parameters.brothersAndFriends
                                        && this.selectedGame.parameters.brothersAndFriends.length > 0
                                )
                        ) && (
                                this.selectedGame.parameters.difficult !== 'Однозначные цифры'
                                || !this.selectedGame.parameters.negativeAnswers
                        ) && !this.selectedGame.parameters.fractions
                        && !this.selectedGame.parameters.roundNumbers
                        && !this.selectedGame.parameters.mirror
            },
            stayIn100Available () {
                return this.selectedGame.parameters.difficult === 'Двузначные цифры'
                        && !this.selectedGame.parameters.jumpOver
            },
            stayIn1000Available () {
                return this.selectedGame.parameters.difficult === 'Трехзначные цифры'
                        && !this.selectedGame.parameters.jumpOver
            },
            interimAnswersDisabled () {
                return this.selectedGame.parameters.stayIn
                        || !!this.selectedGame.parameters.jumpOver
            },
            areBrothersOnlyOptionsDisabled () {
                return this.selectedGame.parameters
                        && (
                                !!this.selectedGame.parameters.interimAnswers
                                || !this.selectedGame.parameters.brothers.length
                        );
            },
            areFriendsOnlyOptionsDisabled () {
                return this.selectedGame.parameters
                        && (!!this.selectedGame.parameters.interimAnswers
                                || (
                                        this.selectedGame.parameters.negativeAnswers
                                        && (
                                                !this.selectedGame.parameters.brothersAndFriends.length
                                                || this.selectedGame.parameters.brothersAndFriendsOptions.onlyAddition
                                        )
                                ) || !this.selectedGame.parameters.friends.length);
            },
            areBrothersAndFriendsOnlyOptionsDisabled () {
                return this.selectedGame.parameters
                        && (!!this.selectedGame.parameters.interimAnswers
                                || (
                                        this.selectedGame.parameters.negativeAnswers
                                        && (
                                                !this.selectedGame.parameters.friends.length
                                                || this.selectedGame.parameters.friendsOptions.onlyAddition
                                        )
                                ) || !this.selectedGame.parameters.brothersAndFriends.length);
            },
            showNegativeAnswersHelpText () {
                return (this.selectedGame.parameters.negativeAnswers || !!this.selectedGame.parameters.interimAnswers)
                        && (
                                (
                                        !this.selectedGame.parameters.friends.length
                                        && !this.selectedGame.parameters.brothersAndFriends.length
                                ) || (
                                        !this.selectedGame.parameters.friends.some(num => num !== 1)
                                        && !this.selectedGame.parameters.brothersAndFriends.length
                                )
                        );
            },
            combiningDisabled () {
                return this.selectedGame.parameters &&
                        (
                                (
                                        this.selectedGame.parameters.difficult === 'Однозначные цифры'
                                        || this.selectedGame.parameters.mirror
                                ) || (
                                        this.selectedGame.parameters.difficult === 'Двузначные цифры'
                                        && this.selectedGame.parameters.roundNumbers
                                )
                        );
            }
        },
        methods: {
            setNumber (number, type) {
                if (type !== 'simple') {
                    this.selectedGame.parameters.simple = this.simple;
                }
                if (this.selectedGame.parameters[type].includes(number)) {
                    this.selectedGame.parameters[type] = this.selectedGame.parameters[type].filter(value => value !== number);
                } else {
                    this.selectedGame.parameters[type].push(number);
                }
            },
            selectMode (mode) {
                this.selectedGame.parameters.mode = mode.value;
            },
            selectDifficult (difficult) {
                this.selectedGame.parameters.difficult = difficult.name;
            },
            roundNumbersHandler (val) {
                this.selectedGame.parameters.roundNumbers = val;
                if (this.selectedGame.parameters.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            fractionsHandler (val) {
                this.selectedGame.parameters.fractions = val;
                if (this.selectedGame.parameters.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            isSimpleDisabled (number) {
                return this.simpleDisabled
                        || (
                                this.selectedGame.parameters.simple.filter(value => value <= 2).length === 1
                                && number <= 2
                                && this.selectedGame.parameters.simple.includes(number)
                        )
            },
            isOnlyJumpOverSetting (number, type) {
                const oppositeType = type === 'friends' ? 'brothersAndFriends' : 'friends';
                return !!this.selectedGame.parameters.jumpOver
                        && this.selectedGame.parameters[type].includes(number)
                        && this.selectedGame.parameters[type].length === 1
                        && !this.selectedGame.parameters[oppositeType].length
            },
            isStayInXAvailable (x) {
                return this['stayIn' + x + 'Available'];
            },

            checkedSelectedItems (type) {
                switch (type) {
                    case 'simple':
                        return this.selectedGame.parameters.simple.length === this.simple.length;
                    case 'brothers':
                        return this.selectedGame.parameters.brothers.length === this.brothers.length;
                    case 'friends':
                        return this.selectedGame.parameters.friends.length === this.friends.length;
                    case 'brothersAndFriends':
                        return this.selectedGame.parameters.brothersAndFriends.length === this.brothersAndFriends.length;
                }
            },
            selectAllForGroup (type) {
                switch (type) {
                    case 'simple':
                        if (this.selectedGame.parameters.simple.length !== this.simple.length || this.selectedGame.parameters.simple.length === 0) {
                            this.selectedGame.parameters.simple = _.cloneDeep(this.simple);
                        } else {
                            this.selectedGame.parameters.simple = [1];
                        }
                        break;
                    case 'brothers':
                        if (this.selectedGame.parameters.brothers.length !== this.brothers.length || this.selectedGame.parameters.brothers.length === 0) {
                            this.selectedGame.parameters.brothers = _.cloneDeep(this.brothers);
                            if (type !== 'simple') {
                                this.selectedGame.parameters.simple = this.simple;
                            }
                        } else {
                            this.selectedGame.parameters.brothers = [];
                        }
                        break;
                    case 'friends':
                        if (this.selectedGame.parameters.friends.length !== this.friends.length || this.selectedGame.parameters.friends.length === 0) {
                            this.selectedGame.parameters.friends = _.cloneDeep(this.friends);
                            if (type !== 'simple') {
                                this.selectedGame.parameters.simple = this.simple;
                            }
                        } else {
                            this.selectedGame.parameters.friends = [];
                        }
                        break;
                    case 'brothersAndFriends':
                        if (this.selectedGame.parameters.brothersAndFriends.length !== this.brothersAndFriends.length || this.selectedGame.parameters.brothersAndFriends.length === 0) {
                            this.selectedGame.parameters.brothersAndFriends = _.cloneDeep(this.brothersAndFriends);
                            if (type !== 'simple') {
                                this.selectedGame.parameters.simple = this.simple;
                            }
                        } else {
                            this.selectedGame.parameters.brothersAndFriends = [];
                        }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .add-sub-form__help-text {
        display: inline-block;
        margin-right: 0;
        padding-top: 0;
        padding-bottom: 0;
    }

    .generator__divider {
        border-bottom: 1px solid $color-grey-300;
        @include stack-space($space-base);
    }

    .generator__buttons-container {
        justify-content: flex-end;
        @include make-grid(0);
    }

    .generator__button {
        width: 100%;
        @include stack-space($space-small);
        @include media($sm) {
            width: unset;
            margin: unset;
            @include inline-space($space-small);
        }

    }

    .generator-form {
        @include stack-space($space-large);
    }

    .generator-form__divider {
        @include stack-space($space-base);
        border-bottom: 1px solid $color-grey-300;
    }

    .generator-form__select {
        width: 100%;
    }

    .generator-form__form-group {
        @include stack-space($space-base);
    }

    .generator-form__numbers-container {
        @include stack-space($space-large);
    }

    .generator-form__numbers {
        display: flex;
        flex-wrap: wrap;
        @include stack-space($space-x-small);
    }

    .generator-form__numbers-header {
        @include text($font-size-16, $font-weight-bold);
        @include stack-space($space-small);
    }

    .generator-form__checkbox-container {
        @include stack-space($space-large);
        display: flex;
        padding-top: $space-x-small;
    }

    .generator-form__checkbox {
        @include inline-space($space-base);
    }
</style>
